import axios from 'axios';

const axiosInstance = axios.create({
  timeout: 60000,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    let proxy = window.location.pathname;
    if (proxy != null && proxy !== '/' && proxy.length > 0) {
      if(proxy[proxy.length - 1] === '/') {
        proxy = proxy.slice(0, -1); 
      }
      config.url = config.url.replace('/api', `${proxy}/api`);
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.error('API request error: ', error);
    Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    console.debug('intercepted response !!!');
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    console.error('API ERROR - data', error.response.data);
    console.error('API ERROR - status', error.response.status);
    console.error('API ERROR - headers', error.response.headers);
    return Promise.reject(error);
  }
);

export default axiosInstance;
